import { useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";
import { useFetchGetByIdServidor } from "@/shared/actions";   // <-- Servidor, no Responsable
import SaveServidor from "../../components/save-servidor/SaveServidor";

export default function UpdateServidorPage() {
  const { id } = useParams();
  const { data, isLoading, isRefetching } = useFetchGetByIdServidor(id!);
  if (isLoading || isRefetching) return <LoaderComponent />;
  return <SaveServidor titulo="Actualizar Servidor" data={data?.data} />;
}